export default function getDefaultState () {
  return {
    clients: {},
    limit: 5,
    errors: {},
    showApiErrors: false,
    loadingTeamMember: false
  }
}
